<template>
    <div>       
        <div class="w-full flex flex-col">
            <div class="modal-header flex items-center justify-between cursor-move">
                <h1 class="flex-1 text-2xl">Edit Task</h1>
                <div @click="hideEditProjectTaskModal">
                    <inline-svg name="close" classes="w-5 h-5 text-white fill-current cursor-pointer"></inline-svg>
                </div>
            </div>
            <div class="bg-white p-4">
                <form class="p-6 border bg-gray-50">
                    <div class="px-2 py-3 flex flex-wrap gap-y-6 gap-x-8">
                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="floor">Type</label>
                            <select name="task_category" v-model="task.task_category" class="mt-0 form-select max-w-fit">
                                <option value=""></option>
                                <option value="Call">Call</option>
                                <option value="Legal Review">Legal Review</option>
                                <option value="Meeting">Meeting</option>
                                <option value="Presentation">Presentation</option>
                                <option value="Status Update">Status Update</option>
                                <option value="Tour">Tour</option>
                                <option value="Miscellaneous">Miscellaneous</option>
                            </select>
                            <div v-if="errors.task_category" class="form-error">{{ errors.task_category[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <div class="flex-1 flex flex-col items-center">
                                <label class="text-sm font-semibold" for="is_all_day">All Day Task?</label>
                                <input type="checkbox" class="mt-2 w-6 h-6 form-checkbox" name="is_all_day" size="20" v-model="task.is_all_day">
                            </div>
                            <div v-if="errors.is_all_day" class="form-error">{{ errors.is_all_day[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="date_time_start">Start</label>
                            <div class="flex items-center">
                                <input type="date" class="form-input" name="date_start" size="20" v-model="date_start">
                                <input v-if="! task.is_all_day" type="time" class="form-input" name="time_start" size="20" v-model="time_start">
                            </div>
                            <div v-if="errors.date_time_start" class="form-error">{{ errors.date_time_start[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="date_time_start">End</label>
                            <div class="flex items-center">
                                <input type="date" class="form-input" name="date_end" size="20" v-model="date_end">
                                <input v-if="! task.is_all_day" type="time" class="form-input" name="time_end" size="20" v-model="time_end">
                            </div>
                            <div v-if="errors.date_time_end" class="form-error">{{ errors.date_time_end[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="floor">Priority</label>
                            <select name="priority" v-model="task.priority" class="mt-0 form-select max-w-fit">
                                <option value=""></option>
                                <option value="Low">Low</option>
                                <option value="Medium">Medium</option>
                                <option value="High">High</option>
                                <option value="Urgent">Urgent</option>
                            </select>
                            <div v-if="errors.priority" class="form-error">{{ errors.priority[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-sm font-semibold" for="task">Task</label>
                            <div class="flex items-center">
                                <input type="text" class="form-input" name="task.task" size="50" v-model="task.task">
                            </div>
                            <div v-if="errors.task" class="form-error">{{ errors.task[0] }}</div>
                        </div>

                        <div class="flex flex-col">
                            <div class="flex-1 flex flex-col items-center">
                                <label class="text-sm font-semibold" for="name">Completed?</label>
                                <input type="checkbox" class="mt-2 w-6 h-6 form-checkbox" name="is_complete" size="20" v-model="task.is_complete">
                            </div>
                            <div v-if="errors.is_complete" class="form-error">{{ errors.is_complete[0] }}</div>
                        </div>

                        <div class="w-full flex flex-col">
                            <label class="text-sm font-semibold" for="description">Note</label>
                            <textarea class="w-full form-textarea" name="note" rows="6" v-model="task.note" :v-text="task.note"></textarea>
                            <div v-if="errors.note" class="form-error">{{ errors.note[0] }}</div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="p-4 flex items-center justify-end bg-gray-100">
                <button class="btn btn-secondary mr-2" @click.prevent="hideEditProjectTaskModal">Close</button>
                <button class="btn btn-green" @click.prevent="saveTask">
                    <span v-if="loading">
                        <inline-svg name="loading-button"></inline-svg>                                
                    </span>
                    <span v-if="! loading">Save Task</span>
                </button>
            </div>
        </div>

        <notifications classes="notification" position="bottom right"></notifications>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            taskData: {
                type: [Array, Object],
                required: true
            }
        },

        data() {
            return {
                task: this.taskData,
                date_start: this.taskData.start_date_formatted,
                time_start: this.taskData.start_time_formatted,
                date_end: this.taskData.end_date_formatted,
                time_end: this.taskData.end_time_formatted,
                errors: '',
                loading: false           
            }
        },

        computed: {
            ...mapState(['projects']),
        },

        methods: {
            hideEditProjectTaskModal() {
                this.$modal.hide('edit-project-task');
            },

            saveTask() {
                this.loading = true;

                if (this.date_start != null) {
                    this.task.date_time_start = this.date_start;

                    if (this.time_start != null) {
                        this.task.date_time_start = this.date_start.concat(' ', this.time_start);
                    }
                }

                if (this.date_end != null) {
                    this.task.date_time_end = this.date_end;

                    if (this.time_end != null) {
                        this.task.date_time_end = this.date_end.concat(' ', this.time_end);
                    }
                }

                this.task.method = "_PATCH";

                axios.patch(`/project/${this.task.project_id}/tasks/${this.task.id}`, this.task)
                    .then(response => {
                        _.remove(this.projects.selectedProject.tasks, task => task.id == this.task.id);
                        this.projects.selectedProject.tasks.push(response.data.task);

                        this.$modal.hide('edit-project-task');

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.errors = error.response.data.errors;
                    }).finally(() => {
                        this.loading = false;
                    });
            }
        }
    }
</script>